import React from 'react'
import { Typography, Box,Divider } from '@mui/material'
import './NestedOL2.css'
import {Link} from 'react-router-dom'
const Disclaimer = () => {
  return (
    <Box
      sx={{
        padding: { xs: '10px', md: '15px' },
        maxWidth: { xs: '100%', md: '800px' },
        margin: '0 auto',
      }}
    >
      <Typography variant='h4' gutterBottom>
        Disclaimer
      </Typography>
      <Divider
        sx={{
          backgroundColor: 'white',
          mb: 2,
          borderBottomWidth: '2px',
          borderRadius: '5px',
        }}
      />
      <Typography variant='body1' gutterBottom textAlign={'justify'}>
        The content on GCCTaxLaws.com (the "Website")
        is for general informational purposes only and provides unofficial
        English translations of tax laws implemented in the GCC region. It
        should <strong>NOT</strong> be considered legal or tax advice. Always
        consult a qualified tax professional before making any decisions based
        on any information accessed through GCCTaxLaws.com.{' '}
      </Typography>
      <Typography variant='subtitle2' fontWeight='bold' gutterBottom>
        If you do not agree to these&nbsp;
        <Link
          component={Link}
          to='/terms-and-conditions'
          target='_blank'
          rel='noopener noreferrer'
          underline='hover'
          color='primary'
          sx={{ fontWeight: 700 }} // keeps the “bold” look inside the sentence
        >
          Terms&nbsp;of&nbsp;use
        </Link>
        , you must discontinue using the Website immediately.
      </Typography>
    </Box>
  )
}

export default Disclaimer
